import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { UnicodeEntity } from '@mews/enums';
import { Companionship, Reservation } from '@mews-commander/data-access';
import { ApplicationState } from '@mews-commander/types';
import { SimpleList, SimpleListItem } from '@optimus-web/core';
import { getCompanionshipsByReservationIds } from '@mews-commander/legacy-entities/src/ducks/companionships';
import { getCurrentEnterpriseReservation } from '@mews-commander/legacy-entities/src/selectors/reservations';
import CompanionListItem from '../CompanionListItem';
import { ReservationPersonCount } from '../../../../components/reservation/ReservationPersonCount';
import { isGroupTabSelected } from '../../selectors';

interface OwnProps {
    reservationId: string;
    scope: string;
    refetchGroup: () => void;
}
interface StateProps {
    companionships: Companionship[];
    reservation: Reservation | undefined;
    shouldDisplayGroupAction: boolean;
}
type CompanionLabelProps = OwnProps & StateProps;

const CompanionLabel = ({
    reservationId,
    companionships,
    reservation,
    shouldDisplayGroupAction,
    refetchGroup,
    scope,
}: CompanionLabelProps) => {
    if (!reservation) return null;

    const { serviceId, occupancyData } = reservation;
    return (
        <>
            {occupancyData && <ReservationPersonCount serviceId={serviceId} reservationOccupancyData={occupancyData} />}
            {UnicodeEntity.NewLine}
            <SimpleList spacing="0" listStyle="none" plain>
                {companionships.map((companionship) => (
                    <SimpleListItem key={`companion-list-item-${companionship.id}`}>
                        <CompanionListItem
                            companionshipId={companionship.id}
                            customerId={companionship.companionId}
                            reservationId={reservationId}
                            shouldDisplayGroupAction={shouldDisplayGroupAction}
                            refetchGroup={refetchGroup}
                            scope={scope}
                        />
                    </SimpleListItem>
                ))}
            </SimpleList>
        </>
    );
};
export default connect<StateProps, undefined, OwnProps, ApplicationState>(
    createStructuredSelector({
        shouldDisplayGroupAction: isGroupTabSelected,
        companionships: (state, { reservationId }) =>
            getCompanionshipsByReservationIds(state, { reservationIds: [reservationId] }),
        reservation: (state, { reservationId }) => getCurrentEnterpriseReservation(state, { id: reservationId }),
    })
)(CompanionLabel);
